import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border backdrop-blur-xl bg-background/80" data-testid="header">
      <div className="container mx-auto px-4 sm:px-6 md:px-12">
        <div className="flex h-16 items-center justify-between">
          {/* Logo */}
          <div 
            className="font-black text-lg sm:text-xl uppercase tracking-tight cursor-pointer hover:text-primary transition-colors"
            onClick={() => navigate('/')}
            data-testid="logo"
          >
            NEXT<span className="text-primary">/</span>GEN
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-testid="nav">
            <a onClick={() => navigate('/services')} className="text-sm uppercase tracking-wider hover:text-primary transition-colors cursor-pointer" data-testid="nav-services">Services</a>
            <a onClick={() => navigate('/pricing')} className="text-sm uppercase tracking-wider hover:text-primary transition-colors cursor-pointer" data-testid="nav-pricing">Pricing</a>
            <a href="#about" className="text-sm uppercase tracking-wider hover:text-primary transition-colors">About</a>
            <a href="#contact" className="text-sm uppercase tracking-wider hover:text-primary transition-colors">Contact</a>
          </nav>

          {/* Desktop CTA */}
          <div className="hidden md:block">
            <Button 
              onClick={() => navigate('/login')}
              className="font-bold uppercase tracking-wider text-sm"
              data-testid="header-login-btn"
            >
              Client Login
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <div className="flex md:hidden items-center gap-2">
            <Button 
              onClick={() => navigate('/login')}
              size="sm"
              className="font-bold uppercase tracking-wider text-xs"
              data-testid="header-login-btn-mobile"
            >
              Login
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              data-testid="mobile-menu-toggle"
            >
              {mobileMenuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </Button>
          </div>
        </div>

        {/* Mobile Navigation Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden border-t border-border py-4" data-testid="mobile-nav">
            <nav className="flex flex-col space-y-4">
              <a 
                onClick={() => { navigate('/services'); setMobileMenuOpen(false); }}
                className="text-sm uppercase tracking-wider hover:text-primary transition-colors py-2 cursor-pointer"
              >
                Services
              </a>
              <a 
                onClick={() => { navigate('/pricing'); setMobileMenuOpen(false); }}
                className="text-sm uppercase tracking-wider hover:text-primary transition-colors py-2 cursor-pointer"
              >
                Pricing
              </a>
              <a 
                href="#about" 
                className="text-sm uppercase tracking-wider hover:text-primary transition-colors py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                About
              </a>
              <a 
                href="#contact" 
                className="text-sm uppercase tracking-wider hover:text-primary transition-colors py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                Contact
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
